import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { PasswordStrengthBarModule } from 'ng2-password-strength-bar';
import { LaddaModule } from 'angular2-ladda';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { MerchantsListPage } from './merchants/list/list.page';
import { MerchantPage } from './merchants/merchant/merchant.page';
import { MerchantsService } from './merchants/merchants.service';

import { TidsListPage } from './tids/list/list.page';
import { TidPage } from './tids/tid/tid.page';
import { TidImportPage } from './tids/import/tid-import.page';

import { TidsService } from '../shared/services/tids.service';

import { CustomerObjectsListPage } from './customer-objects/list/list.page';
import { CustomerObjectPage } from './customer-objects/customer-object/customer-object.page';
import { CustomerObjectsService } from './customer-objects/customer-objects.service';

import { CustomerObjectForm } from './customer-objects/customer-object/customer-object-form/customer-object.form';

import { ExcelModule } from '@progress/kendo-angular-grid';

import { MerchantForm } from './merchants/merchant/merchant-form/merchant.form';
import { MerchantFormFull } from './merchants/merchant/merchant-form-full/merchant.form.full';
import { MerchantsFullService } from './merchants/merchant.full.service';
import { CallsListPage } from './calls/list/list.page';

import { ServicesListPage } from './services/list/list.page';
import { ServicePage } from './services/service/service.page';
import { ServiceCentersListPage } from './service-centers/list/list.page';
import { ServiceCenterPage } from './service-centers/service-center/service-center.page';

import { ServiceModesListPage } from './service-modes/list/list.page';
import { ServiceModePage } from './service-modes/service-mode/service-mode.page';
import { ServiceModeForm } from './service-modes/service-mode/service-mode-form/service-mode.form';

import { ServiceCategoriesListPage } from './service-categories/list/list.page';
import { ServiceCategoryPage } from './service-categories/service-category/service-category.page';

import { ServiceTypeListPage } from './service-types/list/list.page';
import { ServiceTypePage } from './service-types/service-type/service-type.page';

import { AgreementListPage } from './agreements/list/list.page';
import { AgreementPage } from './agreements/agreement/agreement.page';

import { AttachmentTypeConfigurationPage } from './attachment-type-configurations/attachment-type-configuration/attachment-type-configuration.page';
import { AttachmentTypeConfigurationsListPage } from './attachment-type-configurations/list/list.page';
import { AttachmentTypePage } from './attachment-types/attachment-type/attachment-type.page';
import { AttachmentTypesListPage } from './attachment-types/list/list.page';

import { ColorSchemeSettingsPage } from './color-scheme-settings/color-scheme-settings.page';

import { WarehousesListPage } from './warehouses/list/list.page';
import { WarehousePage } from './warehouses/warehouse/warehouse.page';

import { ContragentsService } from './contragents/contragents.service';
import { ContragentsListPage } from './contragents/list/list.page';
import { ContragentPage } from './contragents/contragent/contragent.page';
import { ContragentForm } from './contragents/contragent/contragent-form/contragent.form';
import { ContragentDetailsComponent } from "./contragents/contragent/components/details/contragent-details.component";

import {ContragentAgreementsComponent} from "./contragents/contragent/components/agreements/contragent-agreements.component";
import {ContragentDetailsFormComponent} from "./contragents/contragent/components/details-form/details-form.component";
import {ContragentProjectsComponent} from "./contragents/contragent/components/projects/contragent-projects.component";
import { ContragentProjectsGridComponent } from "./contragents/contragent/components/contragent-projects-grid/contragent-projects-grid.component";
import { RequestStoppingReasonsListPage } from './request-stopping-reasons/list/list.page';
import { RequestStoppingReasonPage } from './request-stopping-reasons/request-stopping-reason/request-stopping-reason.page';
import { StoppingReasonTypeRulesListPage } from './stopping-reason-type-rules/list/list.page';
import { StoppingReasonTypeRulePage } from './stopping-reason-type-rules/stopping-reason-type-rule/stopping-reason-type-rule.page';
import { NomenclaturePage } from './nomenclature/nomenclature.page';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { NomenclatureListPage } from './nomenclature/list/list.page';
import { AddServiceCenterRegionPage } from './contragents/contragent/add-service-center-region/add-service-center-region.page';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { OsmRegionsGridPage } from './contragents/contragent/osm-regions-grid/osm-regions-grid.page';
import { ContragentCustomerObjectsComponent } from './contragents/contragent/components/contragent-customer-objects/contragent-customer-objects.component';
import { LaboratoryExaminationMethodPage } from '../admin/laboratory-examination-methods/object/object.page';
import { LaboratoryExaminationMethodListPage } from '../admin/laboratory-examination-methods/list/list.page';
import { RequestsRoutingModule } from '../requests/requests-routing.module';
import { RequestsModule } from '../requests/requests.module';
import { NewRequestClientInfoComponent } from '../requests/new-request/sub-components/client-info/new-request-client-info.component';
import { NewRequestCustomerObjectInfoComponent } from '../requests/new-request/sub-components/customer-object-info/new-request-customer-object-info.component';
import { AngularYandexMapsModule } from 'angular8-yandex-maps';
import { AgreementDevicesComponent } from './agreements/components/agreement-devices/agreement-devices.component';
import { AgreementCustomerDeviceComponent } from './agreements/components/agreement-customer-device/agreement-customer-device.component';
import { AgreementDeadlineComponent } from './agreements/components/agreement-deadline/agreement-deadline.component';
import { AgreementPlannedMaintenancesComponent } from './agreements/components/agreement-planned-maintenances/agreement-planned-maintenances.component';
import { AgreementMaintenanceServicesComponent } from './agreements/components/agreement-maintenance-services/agreement-maintenance-services.component';
import { AgreementMaintenanceDevicesComponent } from './agreements/components/agreement-maintenance-devices/agreement-maintenance-devices.component';
import { AgreementPriceService } from './agreements/services/agreement-price-service';
import { AgreementPriceComponent } from './agreements/components/agreement-price/agreement-price.component';
import { AgreementSummaryComponent } from './agreements/components/agreement-summary/agreement-summary.component';
import { SearchAgreementsAutoCompleteComponent } from './agreements/components/search-agreements-autocomplete/search-agreements-autocomplete.component';
import { AgreementChangeStatusConfirmationComponent } from './agreements/components/agreement-change-status-confirmation/agreement-change-status-confirmation.component';
import { AgreementNonMainDevicesWarningComponent } from './agreements/components/agreement-non-main-devices-warning/agreement-non-main-devices-warning.component';
import { CustomerObjectServiceCallsListPage } from './customer-object-service-calls/list/list.page';
import { CustomerObjectServiceCallComponent } from './customer-object-service-calls/customer-object-service-call/customer-object-service-call.component';
import { CustomerObjectServiceCallCommentsComponent } from './customer-object-service-calls/customer-object-service-call-comments/customer-object-service-call-comments.component';


@NgModule({
	declarations: [
		ContragentsListPage,
		ContragentPage,
		ContragentForm,
		TidsListPage,
		TidPage,
		TidImportPage,
		MerchantsListPage,
		MerchantPage,
		CustomerObjectsListPage,
		CustomerObjectPage,
		CustomerObjectForm,
		MerchantForm,
		MerchantFormFull,
		CallsListPage,
		ServicesListPage,
		ServicePage,
		ServiceCentersListPage,
		ServiceCenterPage,
		ServiceModesListPage,
		ServiceModePage,
		ServiceModeForm,
		ServiceCategoriesListPage,
		ServiceCategoryPage,
		ServiceTypeListPage,
		ServiceTypePage,
		AgreementListPage,
		AgreementPage,
		ColorSchemeSettingsPage,
		AttachmentTypesListPage,
		AttachmentTypePage,
		AttachmentTypeConfigurationsListPage,
		AttachmentTypeConfigurationPage,
		WarehousesListPage,
		WarehousePage,
		RequestStoppingReasonsListPage,
		RequestStoppingReasonPage,
		ContragentDetailsComponent,
		ContragentAgreementsComponent,
		ContragentProjectsComponent,
		ContragentProjectsGridComponent,
		ContragentDetailsFormComponent,
		StoppingReasonTypeRulesListPage,
		StoppingReasonTypeRulePage,
		NomenclatureListPage,
		NomenclaturePage,
		AddServiceCenterRegionPage,
		OsmRegionsGridPage,
		LaboratoryExaminationMethodPage,
		LaboratoryExaminationMethodListPage,
		NewRequestClientInfoComponent,
		NewRequestCustomerObjectInfoComponent,
		AgreementDevicesComponent,
		AgreementCustomerDeviceComponent,
		AgreementDeadlineComponent,
		AgreementPlannedMaintenancesComponent,
		AgreementMaintenanceServicesComponent,
		AgreementMaintenanceDevicesComponent,
		AgreementPriceComponent,
		AgreementSummaryComponent,
		SearchAgreementsAutoCompleteComponent,
		CustomerObjectServiceCallsListPage,
		CustomerObjectServiceCallComponent,
		CustomerObjectServiceCallCommentsComponent,
		AgreementChangeStatusConfirmationComponent,
		AgreementNonMainDevicesWarningComponent
	],
	entryComponents: [
		CustomerObjectForm,
		ContragentForm,
		MerchantForm,
		MerchantFormFull,
		ServiceModeForm,
		ContragentDetailsComponent,
		ContragentAgreementsComponent,
		ContragentProjectsComponent,
		ContragentDetailsFormComponent,
		AddServiceCenterRegionPage,
		OsmRegionsGridPage,
		NewRequestClientInfoComponent,
		NewRequestCustomerObjectInfoComponent,
		AgreementDevicesComponent,
		AgreementCustomerDeviceComponent,
		AgreementDeadlineComponent,
		AgreementPlannedMaintenancesComponent,
		AgreementMaintenanceServicesComponent,
		AgreementMaintenanceDevicesComponent,
		AgreementPriceComponent,
		AgreementSummaryComponent,
		SearchAgreementsAutoCompleteComponent,
		CustomerObjectServiceCallComponent,
		CustomerObjectServiceCallCommentsComponent,
		AgreementChangeStatusConfirmationComponent,
		AgreementNonMainDevicesWarningComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		FormsModule,
		RouterModule,
		PasswordStrengthBarModule,
		LaddaModule,
		ExcelModule,
		PerfectScrollbarModule,
		ReactiveFormsModule,
		ListViewModule,
		TreeViewModule,
		TextBoxModule,
		AngularYandexMapsModule,
		
	],
	providers: [
		MerchantsService,
		MerchantsFullService,
		TidsService,
		CustomerObjectsService,
		ContragentsService,
		AgreementPriceService,
	],
	exports: [
		NewRequestClientInfoComponent,
		NewRequestCustomerObjectInfoComponent,
		AgreementDevicesComponent,
		AgreementCustomerDeviceComponent,
		AgreementDeadlineComponent,
		AgreementPlannedMaintenancesComponent,
		AgreementMaintenanceServicesComponent,
		AgreementMaintenanceDevicesComponent,
		AgreementPriceComponent,
		AgreementSummaryComponent
	]
})
export class DirectoriesModule { }
